import { createSlice } from "@reduxjs/toolkit";
import {
  sendMessage,
  fetchSellerById,
  markMessagesAsRead,
  SellerMessagesCount
} from "./partChatActions";

const initialState = {
  isSenderLoading: false,
  isConversation: false,
  conversations: [],
  messages: [],
  seller: null,
  isSellerLoading: false,
  isMessagesLoading: false,
  error: null,
  isSellerCountLoading: false,
  totalBuyerUnreadMessages: 0,
  sellerMessagesCount: {
    count: 0,
    planId: null,
    status: null,
    currentPeriodStart: null,
    currentPeriodEnd: null
  }
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setConversations: (state, action) => {
      state.conversations = action.payload;
    },
    setConversationLoading: (state, action) => {
      state.isConversation = action.payload;
    },
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    setSellerMessagesCount: (state, action) => {
      state.sellerMessagesCount = action.payload;
    },
    setMessagesLoading: (state, action) => {
      state.isMessagesLoading = action.payload;
    },
    setTotalUnreadCount: (state, action) => {
      state.totalBuyerUnreadMessages = action.payload;
    },
    resetSellerCount: (state, action) => {
      state.sellerMessagesCount = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendMessage.pending, (state) => {
        state.isSenderLoading = true;
        state.error = null;
      })
      .addCase(sendMessage.fulfilled, (state) => {
        state.isSenderLoading = false;
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.isSenderLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchSellerById.pending, (state) => {
        state.isSellerLoading = true;
      })
      .addCase(fetchSellerById.fulfilled, (state, action) => {
        state.isSellerLoading = false;
        state.seller = action.payload;
      })
      .addCase(fetchSellerById.rejected, (state, action) => {
        state.isSellerLoading = false;
      })
      .addCase(SellerMessagesCount.pending, (state) => {
        state.isSellerCountLoading = true;
      })
      .addCase(SellerMessagesCount.fulfilled, (state, action) => {
        state.isSellerCountLoading = false;
      })
      .addCase(SellerMessagesCount.rejected, (state, action) => {
        state.isSellerCountLoading = false;
      })
      .addCase(markMessagesAsRead.pending, (state) => {})
      .addCase(markMessagesAsRead.fulfilled, (state) => {})
      .addCase(markMessagesAsRead.rejected, (state, action) => {
        state.error = action.payload;
      });
  }
});

export const {
  setConversations,
  setConversationLoading,
  setMessages,
  setMessagesLoading,
  resetSellerCount,
  setSellerMessagesCount,
  setTotalUnreadCount
} = chatSlice.actions;
export default chatSlice.reducer;
